import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useQuestionnaireGet = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["Questionnaire", filters],
    () => {
      const encodedEvents = filters.events.map(encodeURIComponent).join(";");
      return makeAuthedRequest(
        `v1/reporting/questionnaire/eventId/${encodedEvents}`,
        {
          method: "GET",
        }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
